import {
    Component,
    computed,
    EventEmitter,
    inject,
    input,
    Input,
    OnInit,
    Output,
    Signal,
} from '@angular/core';
import { ImpersonationService } from '@features/impersonation/services/impersonation.service';
import { AnimatedCheckmarkComponent } from '@shared/animated-checkmark/animated-checkmark.component';
import { CtaButtonComponent } from '@shared/cta-button/cta-button.component';
import { LoaderComponent } from '@shared/loader/loader.component';

@Component({
    selector: 'app-save-button',
    templateUrl: './save-button.component.html',
    styleUrls: ['./save-button.component.css'],
    imports: [LoaderComponent, CtaButtonComponent, AnimatedCheckmarkComponent],
})
export class SaveButtonComponent implements OnInit {
    @Input() showLoader: boolean;
    @Input() success: boolean;
    @Input() disabled: boolean;
    @Output() onClick = new EventEmitter<Event>();
    additionalClasses = input<string[]>([]);
    variant = input<CtaButtonComponent['variant']>('primary');
    @Input() testId?: string;

    isImpersonating = inject(ImpersonationService).isImpersonating;

    computedClasses: Signal<string[]> = computed(() => {
        return ['p-4 w-full'].concat(this.additionalClasses());
    });

    ngOnInit(): void {}
}
